import { render, staticRenderFns } from "./TabLiveClasses.vue?vue&type=template&id=abd0dcda&"
import script from "./TabLiveClasses.vue?vue&type=script&lang=js&"
export * from "./TabLiveClasses.vue?vue&type=script&lang=js&"
import style0 from "./TabLiveClasses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TabLiveClasses.vue"
export default component.exports